import axios from 'axios'
import { setupInterceptorsTo } from './interseptors'

export const BASE_URL = ''
export const $instance = setupInterceptorsTo(
  axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
  }),
)
